import React from "react";
import {
    AcceptIcon,
    Button,
    ButtonGroup,
    ButtonProps,
    CloseIcon,
    Flex,
    ShorthandCollection,
} from "@fluentui/react-northstar";
import pl from "shared/messages/pl";

export enum EditConfirmationButtonsTypes {
    Accept,
    Cancel,
}

interface EditConfirmationButtonsProps {
    onAccept: () => void;
    onCancel: () => void;
    buttons: EditConfirmationButtonsTypes[];
}

const EditConfirmationButtons: React.FC<EditConfirmationButtonsProps> = (props: EditConfirmationButtonsProps) => {
    let buttons: ShorthandCollection<ButtonProps, Record<string, {}>> | undefined = [];
    if (props.buttons.includes(EditConfirmationButtonsTypes.Accept)) {
        buttons.push({
            icon: <AcceptIcon />,
            key: pl.taskDetails.dropdown.saveChanges,
            iconOnly: true,
            title: pl.taskDetails.dropdown.saveChanges,
            size: "small",
            onClick: props.onAccept,
        });
    }

    if (props.buttons.includes(EditConfirmationButtonsTypes.Cancel)) {
        buttons.push({
            icon: <CloseIcon />,
            key: pl.taskDetails.dropdown.cancel,
            iconOnly: true,
            title: pl.taskDetails.dropdown.cancel,
            size: "small",
            onClick: props.onCancel,
        });
    }

    return (
        <Flex.Item align="end">
            <ButtonGroup buttons={buttons} />
        </Flex.Item>
    );
};

export default EditConfirmationButtons;
